var map = {
	"./copyright1.png": 79656,
	"./copyright10.png": 47674,
	"./copyright11.png": 53859,
	"./copyright12.png": 75528,
	"./copyright13.png": 23921,
	"./copyright14.png": 79358,
	"./copyright15.png": 55143,
	"./copyright16.png": 4460,
	"./copyright17.png": 16085,
	"./copyright18.png": 86930,
	"./copyright19.png": 8475,
	"./copyright2.png": 16515,
	"./copyright20.png": 34827,
	"./copyright21.png": 13698,
	"./copyright22.png": 61881,
	"./copyright3.png": 94938,
	"./copyright4.png": 69237,
	"./copyright5.png": 86348,
	"./copyright6.png": 54823,
	"./copyright7.png": 67134,
	"./copyright8.png": 82377,
	"./copyright9.png": 11200,
	"./patent1.png": 85289,
	"./patent2.png": 20146,
	"./patent3.png": 69147,
	"./patent4.png": 59204,
	"./patent5.png": 1709,
	"./patent6.png": 11030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8539;